














import { Component, Vue } from 'vue-property-decorator';
import { ILoginCredentials } from '@/interfaces';
import { showAxiosErrorMessage } from '@/utils';

import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';
import Btn from '@/components/Btn.vue';
import Splitter from '@/components/Splitter.vue';
import LoginForm from '@/components/forms/LoginForm.vue';

@Component({
  name: 'login-page',
  components: { Field, TextField, Btn, Splitter, LoginForm }
})
export default class LoginComponent extends Vue {
  /**
   * Loading data into the system
   */
  public loading = false;

  /**
   * The callback method to deal with login
   */
  public async submit(model: ILoginCredentials) {
    try {
      this.loading = true;

      if (await this.$store.dispatch('login', model)) {
        this.$alert.success('Successfully logged in');
        this.$router.push('/');
      } else {
        this.$alert.danger('Unable to login');
      }
    } catch (ex) {
      showAxiosErrorMessage(ex);
    } finally {
      this.loading = false;
    }
  }
}
